import { Injectable } from '@angular/core';
import { BehaviorSubject, from, Observable } from 'rxjs';
import { NotificacaoView } from '../../models/NotificacaoView';
import { AuthService } from '../auth/auth.service';
import { HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import axiosClient from '../../../shared/axios/axios-client';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private unreadAvisosCountSubject = new BehaviorSubject<number>(0);
  public unreadAvisosCount$: Observable<number> = this.unreadAvisosCountSubject.asObservable();
  private unreadNotificacoesCountSubject = new BehaviorSubject<number>(0);
  public unreadNotificacoesCount$: Observable<number> = this.unreadNotificacoesCountSubject.asObservable();

  constructor(private authService: AuthService) { }

  private apiUrl = `${environment.apiUrl}/notificacao`;

  getUnreadAvisosCount(): number {
    return this.unreadAvisosCountSubject.value;
  }

  getMinhasNotificacoes(): Observable<{ notificacoes: NotificacaoView[] }> {
    const url = `${this.apiUrl}/meus`;

    return from(axiosClient.get<{notificacoes: NotificacaoView[]}>(url).then(res => res.data));
  }

  getUnreadNotificacoesCountAPI(): Observable<{ count: number }> {
    return new Observable(observer => {
      this.getMinhasNotificacoes().subscribe({
        next: (response) => {
          const unreadCount = response.notificacoes.filter(notificacao => {
            const isUnread = notificacao.status?.toLowerCase() !== 'visualizado';
            return isUnread;
          }).length;
          observer.next({ count: unreadCount });
          observer.complete();
        },
        error: (error) => {
          observer.error(error);
        }
      });
    });
  }

  visualizarNotificacao(idNotificacao: number) {
    const url = `${this.apiUrl}/visualizado`;
    return from(axiosClient.put(url, [idNotificacao]).then(res => res.data))
  }

  setUnreadAvisosCount(count: number): void {
    this.unreadAvisosCountSubject.next(count);
  }

  setUnreadNotificacoesCount(count: number): void {
    this.unreadNotificacoesCountSubject.next(count);
  }

  incrementUnreadAvisosCount(): void {
    const currentCount = this.unreadAvisosCountSubject.value;
    this.unreadAvisosCountSubject.next(currentCount + 1);
  }

  incrementUnreadNotificacoesCount(): void {
    const currentCount = this.unreadNotificacoesCountSubject.value;
    this.unreadNotificacoesCountSubject.next(currentCount + 1);
  }

  decrementUnreadAvisosCount(): void {
    const currentCount = this.unreadAvisosCountSubject.value;
    if (currentCount > 0) {
      this.unreadAvisosCountSubject.next(currentCount - 1);
    }
  }

  decrementUnreadNotificacoesCount(): void {
    const currentCount = this.unreadNotificacoesCountSubject.value;
    if (currentCount > 0) {
      this.unreadNotificacoesCountSubject.next(currentCount - 1);
    }
  }

  resetUnreadAvisosCount(): void {
    this.unreadAvisosCountSubject.next(0);
  }

  resetUnreadNotificacoesCount(): void {
    this.unreadNotificacoesCountSubject.next(0);
  }

  handleNewAvisoReceived(): void {
    this.incrementUnreadAvisosCount();
  }

  handleNewNotificacaoReceived(): void {
    this.incrementUnreadNotificacoesCount();
  }

  handleAvisoVisualized(): void {
    this.decrementUnreadAvisosCount();
  }

  handleNotificacaoVisualized(): void {
    this.decrementUnreadNotificacoesCount();
  }
}
